const resources = [
  {
    id: "african-precision-health-implementation-brief-2026",
    title: "African Precision Health Implementation Brief — 2026",
    type: "Implementation Brief",
    date: "August 2026",
    description:
      "From Innovation to Implementation: Building the Connective Capacity for Africa’s Precision-Health Future.",
    file: "/resources/african-precision-health-implementation-brief-2026.pdf",
  },

  {
    id: "90-day-mobilisation-african-precision-health",
    title: "From Conversation to Implementation",
    type: "Concept Note",
    date: "August 2026",
    description:
      "A 90-Day Mobilisation for African Precision Health, outlining a practical pathway from shared diagnosis toward defined implementation opportunities.",
    file: "/resources/90-day-mobilisation-african-precision-health.pdf",
  },

  {
    id: "from-african-health-data-to-actionable-intelligence",
    title: "From African Health Data to Actionable Intelligence",
    type: "Seminar Material",
    date: "October 2026",
    description:
      "A synthesis of the Institute conversation on connecting African health data and evidence to better decisions and care.",
    url: "/institute/seminars/from-african-health-data-to-actionable-intelligence",
    action: "Read the Summary",
  },
];

export default resources;